import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYemen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1827)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C17.1596 24 21.5581 20.7435 23.2536 16.1739H0.746384C2.4419 20.7435 6.84041 24 12 24Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 0C6.84041 0 2.4419 3.2565 0.746384 7.82611H23.2536C21.5581 3.2565 17.1596 0 12 0Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1827",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgYemen;
